module.exports = __webpack_public_path__ + "assets/img-error.157d8941.svg";